import axios from "axios";

declare global {
  interface Window {
    env: any;
  }
}

const baseURL = process.env.REACT_APP_TUNISIAEDFAPAYAPI;
const api = axios.create({
  baseURL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});
const Attestationapi: any = axios.create({
  baseURL: process.env.REACT_APP_ATTESTATION,
});

// Checkout-related endpoints that should NOT trigger logout on 401
const checkoutEndpoints = [
  "payment/orderdtl",
  "payment/status",
  "payment/initiate",
  "payment/refund",
  "clictopay/order-status",
  "clictopay/checkout",
  "clictopay/checkout-binding",
  "clictopay/getbinding",
  "clictopay/unbinding",
  "clictopay/get-merchant-url",
  "tabby-pay/checkout",
  "tamarapay/checkout",
  "tamarapay/initiate",
  "urpay/initiate",
  "urpay/execute",
  "billAndPaymentGateway/v1/bill",
  "products/template",
];

// Check if the request URL is a checkout endpoint
const isCheckoutEndpoint = (url: string): boolean => {
  if (!url) return false;
  return checkoutEndpoints.some((endpoint) => url.includes(endpoint));
};

// Check if current route is a public checkout route
const isPublicCheckoutRoute = (): boolean => {
  const pathname = window.location.pathname;
  return (
    pathname.includes("/merchant/checkout") ||
    pathname.includes("/merchant/checkout2") ||
    pathname.includes("/recurringPayment/processing") ||
    pathname.includes("/pay-by-link/")
  );
};

const SetupInterceptors = (http: any) => {
  http.interceptors.request.use(
    (config: any) => {
      config.headers["content-type"] = "application/json";
      config.headers["Cache-Control"] = "max-age=31536000, no-cache";
      return config;
    },
    (error: any) => {
      const status = error?.request?.status || 0;
      const resBaseURL = error?.request?.config?.baseURL;
      const requestUrl = error?.request?.config?.url || "";

      // Skip logout for checkout endpoints
      if (
        resBaseURL === baseURL &&
        status === 401 &&
        !isCheckoutEndpoint(requestUrl)
      ) {
        if (localStorage.getItem("token")) {
          localStorage.clear();
          //window.location.assign('/login')
          return Promise.reject(error);
        } else {
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    },
  );

  http.interceptors.response.use(
    function (response: any) {
      return response;
    },
    function (error: any) {
      const status = error?.response?.status || 0;
      const resBaseURL = error?.response?.config?.baseURL;
      const requestUrl = error?.response?.config?.url || "";

      // Check if we are on the public payment status page
      const isPublicPage = window.location.pathname.includes(
        "/recurringPayment/processing",
      );

      // Skip logout for checkout endpoints or when on public checkout routes
      if (resBaseURL === baseURL && status === 401) {
        if (
          !isCheckoutEndpoint(requestUrl) &&
          !isPublicCheckoutRoute() &&
          !isPublicPage
        ) {
          window.location.assign("/login");
          localStorage.setItem("tokExp", "1");
        }
        return Promise.reject(error);
      } else if (resBaseURL === baseURL && status === 500) {
        //window.location.assign('/login')
        localStorage.setItem("errRes", "1");
        return Promise.reject(error);
      }
      return Promise.reject(error);
    },
  );
};

SetupInterceptors(api);
SetupInterceptors(Attestationapi);

export default api;
export { Attestationapi };
